import React, { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Type } from '@lendi/lala-react';

import { getViewType } from '@funnels/utils';

const CustomerView = React.lazy(() => import('@funnels/customer-view/src/CustomerView'));
const TeamView = React.lazy(() => import('@funnels/team-view/src/TeamView'));

function Monolith() {
  const isTeamView = getViewType() === Type.Team;

  return (
    <StrictMode>
      <Suspense fallback={null}>{isTeamView ? <TeamView /> : <CustomerView />}</Suspense>
    </StrictMode>
  );
}

ReactDOM.render(<Monolith />, document.getElementById('app'));
